import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Actions from 'actions/Actions';
import { isInventoryAwareStorePickerEnabledSelector } from 'viewModel/selectors/shopYourStore/isInventoryAwareStorePickerEnabledSelector';
import { Link } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import PickupOosErrorEN from 'components/RwdBasket/shared/PickupOosError/locales/PickupOosError_en_US';
import PickupOosErrorFR from 'components/RwdBasket/shared/PickupOosError/locales/PickupOosError_fr_CA';

const { getLocalisedDataFromResource } = localeUtils;
const getText = getLocalisedDataFromResource(PickupOosErrorEN, PickupOosErrorFR);

function PickupOosError({ message }) {
    const dispatch = useDispatch();
    const isIASPEnabled = useSelector(isInventoryAwareStorePickerEnabledSelector);

    if (!isIASPEnabled) {
        return <>{message}</>;
    }

    const handleChooseStoreClick = () => {
        dispatch(
            Actions.showStoreSwitcherModal({
                isOpen: true,
                showStoreDetails: true,
                entry: 'pickup basket oos change location'
            })
        );
    };

    return (
        <>
            {getText('oosMessagePrefix')}
            <Link
                color='blue'
                onClick={handleChooseStoreClick}
                data-at={Sephora.debug.dataAt('choose_different_store_link')}
            >
                {getText('oosMessageLink')}
            </Link>
            {getText('oosMessageSuffix')}
        </>
    );
}

export default wrapFunctionalComponent(PickupOosError, 'PickupOosError');
